import { render } from "./NewsBox.vue?vue&type=template&id=92a07de8&scoped=true"
import script from "./NewsBox.vue?vue&type=script&lang=js"
export * from "./NewsBox.vue?vue&type=script&lang=js"

import "./NewsBox.vue?vue&type=style&index=0&id=92a07de8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-92a07de8"

export default script